<template>
    <v-container>
        <h1 class="display-1">Add Perk To Class - {{ characterClass.name }}</h1>

        <v-card class="mt-4">
            <v-card-text>
                <v-text-field v-model="form.amount"
                              type="number"
                              @keydown.enter="addPerkToCharacterClass"
                              label="Number of checkboxes"/>
                <v-text-field v-model="form.description"
                              @keydown.enter="addPerkToCharacterClass"
                              label="Description"/>
                <v-btn color="secondary"
                       @click="$router.push({name: 'character-class', params: {characterClassId: characterClass.id}})"
                       class="mr-2">Cancel
                </v-btn>
                <v-btn color="primary" @click="addPerkToCharacterClass" :loading="loading">Add Perk</v-btn>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import CharacterClassService from "../services/CharacterClassService";

  export default {
    data: () => ({
      loading: false,
      form: {
        amount: null,
        description: null
      },
      characterClass: null
    }),

    created() {
      this.viewCharacterClass();
    },

    methods: {
      viewCharacterClass() {
        CharacterClassService.view(this.$route.params.characterClassId)
          .then(response => {
            this.characterClass = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      addPerkToCharacterClass() {
        this.loading = true;
        this.form.party_id = this.$route.params.partyId;

        CharacterClassService.addPerk(this.characterClass.id, this.form)
          .then(() => {
            this.$router.push({name: 'character-class', params: {characterClassId: this.characterClass.id}});
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
          });
      }
    }
  };
</script>
